import React from 'react';
import { useDispatch } from 'react-redux';
import { SelectPolicyRenewalLoaded } from 'actions';
import { Back, Button } from 'components/quashed';
import Title from 'components/title';
import { DASHBOARD_ROUTE } from 'constants/routes';
import RenewalUpdate from 'containers/renewal-update';
import { dateLessThanOrEqualToDays } from 'helpers';
import styles from '../styles/PolicyDetailsRenewal.module.scss';

const EXPIRED_TITLE = 'Your policy has expired - Update now';
const EXPIRING_TITLE = 'Have you received your updated renewal? Update now';
const CONTINUE_TITLE = 'You have a pending renewal - Continue now';
const SUBTITLE =
  'Keep your information up to date! Your renewal PDF should have been emailed to you by your insurer.';
const CONTINUE_SUBTITLE =
  'Your new policy was uploaded but the details have not been confirmed. Save your changes now.';

const getTitle = (renewalDate, pendingRenewal) => {
  if (pendingRenewal) {
    return CONTINUE_TITLE;
  }

  return dateLessThanOrEqualToDays(0, renewalDate)
    ? EXPIRED_TITLE
    : EXPIRING_TITLE;
};

const PolicyDetailsRenewal = ({
  className,
  pendingRenewal,
  policy,
  showMarketScanBtn,
}) => {
  const dispatch = useDispatch();
  const title = getTitle(policy.renewalDate, pendingRenewal);

  const handleContinue = () => {
    dispatch(
      SelectPolicyRenewalLoaded(R.assoc('isUpload', true, pendingRenewal)),
    );
  };

  return (
    <div className={classnames(styles.container, className)}>
      <Title
        titleClassName={styles.title}
        title={title}
        subtitle={pendingRenewal ? CONTINUE_SUBTITLE : SUBTITLE}
      />
      {pendingRenewal ? (
        <div className={styles.buttons}>
          <Button
            className={styles.continue}
            text="Continue"
            onClick={handleContinue}
          />
          <Back
            className={styles.back}
            link={DASHBOARD_ROUTE}
            text="Back to dashboard"
          />
        </div>
      ) : (
        <RenewalUpdate policy={policy} showMarketScanBtn={showMarketScanBtn} />
      )}
    </div>
  );
};

export default PolicyDetailsRenewal;
